import {PANELMANAGER_SET_PANEL_INVALID} from '../../constants';

export type SetPanelInvalidAction = {
    type : typeof PANELMANAGER_SET_PANEL_INVALID;
    panelKey : string;
    invalid : boolean;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {boolean} invalid
 *
 * @return {SetPanelInvalidAction}
 */
const setPanelInvalid = ( panelKey : string, invalid : boolean ) : SetPanelInvalidAction => {
    return {
        type: PANELMANAGER_SET_PANEL_INVALID,
        panelKey,
        invalid
    };
}
export type SetPanelInvalid = typeof setPanelInvalid;

export default setPanelInvalid;
